import { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  text: {
    primary: '#FFFFFF',
    secondary: '#8F8F8F',
  },
  primary: {
    main: '#5A47D3',
    dark: '#5A47D3',
    light: '#5A47D31A',
    contrastText: '#FFFFFF',
  },
  primaryExtended: {
    opacityBackgroundText: '#9E8FFF',
    opacityBackgroundBackground: '#9E8FFF26',
  },
  secondary: {
    main: '#FF0000',
    contrastText: '#FF0000',
  },
  background: {
    default: '#1D1D1D',
    paper: '#161616',
  },
  backgroundExtended: {
    card: '#242425',
  },
  backdrop: {
    default: '#00000080',
  },
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
  error: {
    main: '#FF7B6B',
    dark: '#FF5B47',
    light: '#FF7B6B33',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FF9500',
    dark: '#D86700',
    light: '#FF95001F',
  },
  info: {
    main: '#7F7AFF',
    dark: '#5954E2',
    light: '#7F7AFF33',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#2EA9A1',
    dark: '#4DA29D',
    light: '#2EA9A124',
    contrastText: '#FFFFFF',
  },
  divider: '#2B2B2B',
  grey: {
    900: '#FCF6FA',
    800: '#F4EEF2',
    700: '#848484',
    600: '#787878',
    500: '#5B5B5B',
    400: '#3E3E3E',
    300: '#353535',
    200: '#2C2C2C',
    100: '#2A2A2A',
    50: '#232323',
  },
  brown: {
    900: '#FF0000',
    800: '#FF0000',
    700: '#FF0000',
    600: '#FF0000',
    500: '#FF0000',
    400: '#FF0000',
    300: '#FF0000',
    200: '#FF0000',
    100: '#FF0000',
    50: '#FF0000',
  },
};
